"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var SmileyHappyFill = function SmileyHappyFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "SmileyHappyFill"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.48567 0 0 4.48567 0 10C0 15.5143 4.48567 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48567 15.5143 0 10 0ZM13.0557 5.41667C13.8997 5.41667 14.5833 6.101 14.5833 6.94433C14.5833 7.78833 13.8997 8.472 13.0557 8.472C12.2117 8.472 11.528 7.78833 11.528 6.94433C11.5277 6.101 12.2113 5.41667 13.0557 5.41667ZM6.94433 5.41667C7.78833 5.41667 8.472 6.101 8.472 6.94433C8.472 7.78833 7.78833 8.472 6.94433 8.472C6.10033 8.472 5.41667 7.78833 5.41667 6.94433C5.41667 6.101 6.10033 5.41667 6.94433 5.41667ZM10 16.111C7.15133 16.111 4.65266 13.6123 4.65266 10.7637C4.65266 10.342 4.995 9.99967 5.41667 9.99967C5.83833 9.99967 6.18067 10.342 6.18067 10.7637C6.18067 12.7627 8.001 14.583 10 14.583C11.999 14.583 13.8193 12.7627 13.8193 10.7637C13.8193 10.342 14.1617 9.99967 14.5833 9.99967C15.005 9.99967 15.3473 10.342 15.3473 10.7637C15.3473 13.6123 12.8487 16.111 10 16.111Z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = SmileyHappyFill;
exports["default"] = _default;